import { render, staticRenderFns } from "./IbmData.vue?vue&type=template&id=8f7aac10&scoped=true&"
import script from "./IbmData.vue?vue&type=script&lang=js&"
export * from "./IbmData.vue?vue&type=script&lang=js&"
import style0 from "./IbmData.vue?vue&type=style&index=0&id=8f7aac10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7aac10",
  null
  
)

export default component.exports